import React, { useState, useCallback } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Screen, Section, Button } from '../design/primitives';
import DreamList from '../components/DreamList';
import DreamForm from '../components/forms/DreamForm';

const DreamsPage: React.FC = () => {
  const [isDreamFormOpen, setIsDreamFormOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleDreamCreated = useCallback(() => {
    setRefreshKey(prevKey => prevKey + 1);
  }, []);

  return (
    <Screen>
      <Section
        title="Dreams"
        action={
          <Button
            variant="primary"
            onClick={() => setIsDreamFormOpen(true)}
            icon={<PlusIcon style={{ width: '16px', height: '16px' }} />}
          >
            New Dream
          </Button>
        }
      >
        <DreamList key={refreshKey} />
      </Section>

      <DreamForm
        isOpen={isDreamFormOpen}
        onClose={() => setIsDreamFormOpen(false)}
        onDreamCreated={handleDreamCreated}
      />
    </Screen>
  );
};

export default DreamsPage;
